import { Box, Card, CardHeader, Divider, Stack } from '@mui/material'
import { memo } from 'react'
import { faCircleCheck } from '@fortawesome/pro-duotone-svg-icons'

import { formatTicks, titleCase } from '../../util/string.helpers'
import { Label } from '../shared/label'
import UserAvatar from '../../layouts/components/user-avatar'
import { extractInitials } from '../../util/wallet/common.helpers'
import ProgressTitle from '../shared/progressBar/ProgressTitle'
import FaIcon from 'src/components/shared/faIcon/FaIcon'
import Text from '../shared/text/Text'
import InvitesLoading from './InvitesLoading'

const Invites = ({
  t,
  title,
  desc,
  icon,
  data,
  isActive,
  isProcessing,
  count,
  tiers
}) => {
  return (
    <Card>
      <CardHeader title={title} subheader={desc} />
      <Label color='primary' sx={{ position: 'absolute', right: 20, top: 20 }}>
        {formatTicks(count)}
      </Label>
      <Stack
        spacing={1.5}
        p={3}
        divider={<Divider sx={{ borderStyle: 'dashed' }} />}
      >
        {isProcessing ? (
          <InvitesLoading />
        ) : (
          data.map((item, index) => (
            <Invite
              key={index}
              icon={icon}
              t={t}
              {...item}
              isActive={isActive}
              tier={tiers?.[item.referredUser?.tierId]}
            />
          ))
        )}
      </Stack>
    </Card>
  )
}

export default memo(Invites)

const Invite = ({
  t,
  referredUser: { firstName, secondName },
  tier,
  icon,
  isActive
}) => {
  const userInitials = extractInitials(firstName, secondName)
  return (
    <Box
      sx={{
        gap: 2,
        display: 'flex',
        alignItems: 'center',
        flexDirection: { sm: 'row' }
      }}
    >
      <UserAvatar
        sx={{ p: '2px' }}
        label={userInitials}
        size={48}
        noAnimation
      />
      <Stack flexGrow={1} alignItems='flex-start'>
        <ProgressTitle
          name={titleCase(`${firstName} ${secondName}`)}
          sx={{ mb: 0 }}
        />
        <Text
          label={
            <>
              <FaIcon
                icon={faCircleCheck}
                style={{
                  color: 'var(--palette-primary-main)',
                  fontSize: 20
                }}
              />
              <>{t('referral.created-account')}</>{' '}
              {tier && (
                <>
                  /
                  <FaIcon
                    icon={icon}
                    style={{
                      ...(isActive && { color: 'var(--palette-primary-main)' }),
                      fontSize: 20
                    }}
                  />
                  <>{t('referral.status', { name: tier.name })}</>
                </>
              )}
            </>
          }
          color='text.secondary'
          variant='subtitle2'
          sx={{
            display: 'flex',
            flexDirection: 'row',
            gap: 0.5,
            alignItems: 'center',
            flexWrap: 'wrap'
          }}
        />
      </Stack>
    </Box>
  )
}
